export function parseStaticApiOverrides (value: string | undefined): Record<string, string> {
    if (!value?.trim()) return {};

    try {
        const overrides: unknown = JSON.parse(value);
        if (overrides === null || typeof overrides !== 'object' || Array.isArray(overrides)
            || !Object.values(overrides).every(override => typeof override === 'string')) {
            throw new Error('Expected an object mapping API endpoint names to environment strings');
        }
        return overrides as Record<string, string>;
    } catch (error) {
        console.warn('Ignoring invalid VITE_APP_STATIC_API_OVERRIDES', error);
        return {};
    }
}

export function resolveStaticApiEndpoint (endpoint: string, overrides: Record<string, string> = {}): string {
    const lowerEndpoint = endpoint.toLowerCase();
    const baseUrl = Object.keys(overrides)
        .sort((a, b) => b.length - a.length)
        .find(candidate => {
            if (!lowerEndpoint.startsWith(candidate.toLowerCase())) return false;
            const suffix = endpoint.substring(candidate.length);
            return suffix === '' || /^[/?#]/.test(suffix);
        });

    return baseUrl === undefined ? endpoint : overrides[baseUrl] + endpoint.substring(baseUrl.length);
}
